/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { IntegrationRequestBodyCategory } from './integrationRequestBodyCategory';

export interface IntegrationRequestBody {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name: string;
  email: string;
  /**
     * @minLength 1
     * @maxLength 255
     */
  integration: string;
  details?: string | null;
  category?: IntegrationRequestBodyCategory;
}
